module.exports = __webpack_public_path__ + "media/images/order_menu-7541aaf66f672d757e6ff3ae2e4bc782.svg";